<template>
  <option :data-obfuscate="quantumObfuscate" :value="value">{{ label }}</option>
</template>

<script>
export default {
  name: "SelectOption",
  props: ["label", "value", "quantumObfuscate"]
};
</script>
